import { Link } from 'react-router-dom';
import { Box } from '@mui/material';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';

interface FHPageLinkProps {
  to: string;
  label: string;
}

function FHPageLink({ to, label }: FHPageLinkProps) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
      <Link to={to}>
        <KeyboardArrowLeftIcon sx={{ height: '21px', width: '21px', mb: -0.7 }} />
        {label}
      </Link>
    </Box>
  );
}

export default FHPageLink;
